import { ITraining } from '../../types/interfaces/training';

/** True if the training was shared with this user (recipient in availableToUsers). */
export function isTrainingSharedWithUser(
  training: ITraining | null | undefined,
  userId: string | undefined,
): boolean {
  if (!training || !userId) {
    return false;
  }
  return (training.availableToUsers ?? []).some((u) => u.id === userId);
}
